export enum InvoiceVerificationStatus {
  MATCHED = 'MATCHED',
  AWAITING_DELIVERY_DATA = 'AWAITING_DELIVERY_DATA',
  REQUIRES_ATTENTION = 'REQUIRES_ATTENTION',
}
